module.exports = __webpack_public_path__ + "media/top/helpful_info_article_02-acef9c56.svg";